import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router/router'
import store from './store/index'
import apis from './api/index'
import utils from './utils'
import { Button, Cell, Toast } from 'vant'
import './components'
import getCookies from '@/utils/getCookies'
import getQueryString from '@/utils/getQueryString'
import './assets/less/index.less'
import './utils/rem'
// 网络监听
import networkListening from './utils/networkListening'
import VConsole from 'vconsole'
import configParams from './api/config'
import $language from './lang'
configParams.vconsole && new VConsole()
Vue.use(networkListening)
Vue.use(Button)
Vue.use(Cell)
Vue.use(Toast)
// 全局配置Toast
Toast.setDefaultOptions({
    forbidClick: true,
    duration: 1500
})
// 注册 bridge.js 到 window
utils.windowBind(require('./utils/jsbridge.js'))
Vue.prototype.$Toast = Toast
Vue.prototype.$apis = apis
Vue.prototype.$language = $language
Vue.prototype.$getCookies = getCookies
Vue.prototype.$getQueryString = getQueryString
Vue.config.productionTip = false
// 获取皮肤名称
store.dispatch('GET_THEME_CONFIG')

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
